var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportingCard',{attrs:{"title":"Leads Per Hour"}},[_c('HeatmapChart',{attrs:{"title":"Leads Per Hour","color":_vm.chartColors.purple,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }